import { render, staticRenderFns } from "./RolesView.vue?vue&type=template&id=a8aa2694&scoped=true"
import script from "./RolesView.vue?vue&type=script&lang=js"
export * from "./RolesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8aa2694",
  null
  
)

export default component.exports